import { DOCUMENT } from '@angular/common';
import { ChangeDetectionStrategy, Component, HostBinding, inject, Input, OnDestroy, OnInit } from '@angular/core';

import { ChannelService } from '@usheru-hff/sdk/channel';
import { MetatagsService } from '@usheru-hff/shared/utils-metatag';
import { PageLoaderService } from '@usheru-hff/shared/utils-navigation';

@Component({
    selector: 'default-loader',
    templateUrl: './default-loader-page.component.html',
    styleUrls: ['./default-loader-page.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class DefaultLoaderPageComponent implements OnInit, OnDestroy {
  private readonly doc = inject(DOCUMENT);

  @HostBinding('class.default-loader') selectClass = true;
  @HostBinding('class.active')
  visible = true;

  @HostBinding('style.background') backgroundStyle = '';
  @Input() set background(background: string) {
    this.backgroundStyle = background;
  }

  @Input()
  channelLogo?: string;
  @Input() logoParams?: unknown;
  @Input() dotsColor?: string;
  @Input() logoActive?: boolean = true;

  subscriptions: unknown = [];

  constructor(
    private channelService: ChannelService,
    private loaderService: PageLoaderService,
    private metatagsService: MetatagsService
  ) {
    this.subscriptions = loaderService.visible.subscribe(visible => (this.visible = visible));
  }
  ngOnDestroy(): void {
    this.subscriptions = null;
  }

  ngOnInit(): void {
    if (this.logoActive) {
      if (!this.channelLogo) this.channelLogo = this.channelService.channel.logoUrl;
      if (!this.logoParams) this.logoParams = { height: 50 };
    }
    this.setDefaultMetatags();
  }
  setDefaultMetatags() {
    const homeMetatagTitle = this.channelService.channel.getCustomPage('home')?.metaTitle;
    const homeMetatagDesc = this.channelService.channel.getCustomPage('home')?.metaDescription;
    this.metatagsService.setMetaTags({
      url: this.doc.location?.href,
      title: homeMetatagTitle || `meta.page.default.title`,
      description: homeMetatagDesc || `meta.page.default.description`
    });
  }
}
